import { home_data, user_data } from 'src/stores/account/user';
import { APP_VERSION_FOR_PROMO_PREMIUM } from 'src/constants';
import compareVersions from 'compare-versions';
import type { ModalConfig } from 'src/types/Modals';
import { get } from 'svelte/store';
import { version } from '../../../package.json';
import PromoPremiumModal from 'src/components/Promotions/PromoPremiumModal.svelte';
import { NoPremiumVoucherCheckRule } from './rules/NoPremiumVoucherRule';

export const PromoPremiumModalConfig: ModalConfig = {
	id: 'promoPremium',
	component: PromoPremiumModal,
	props: {
		priority: 80, // Medium priority
		showModal: true,
	},
	rules: [
		{
			check: () => {
				const homeData = get(home_data);
				const userData = get(user_data);
				const realAppVersion = version.split('-')[0];
				const promoPremiumVersion = APP_VERSION_FOR_PROMO_PREMIUM;

				return (
					!!userData.premium &&
					(!homeData?.promoPremium
						? compareVersions.compare(promoPremiumVersion, realAppVersion, '=')
						: compareVersions.compare(promoPremiumVersion, homeData.promoPremium, '>') &&
							compareVersions.compare(promoPremiumVersion, realAppVersion, '='))
				);
			},
			expected: true,
		},
		NoPremiumVoucherCheckRule,
	],
};
